<template>
  <Transition name="fade">
    <div @click="navigationDrawerStore.close()"
      v-if="navigationDrawerStore.isOpen"
      class="z-40 fixed top-0 left-0 scrim h-screen w-screen bg-black/25">
    </div>
  </Transition>

  <Transition name="grow-right">
    <div v-if="navigationDrawerStore.isOpen"
      class="pt-safe-flush flex flex-col px-3 rounded-r-xl container fixed top-0 left-0 z-50 h-screen max-w-90 bg-background overflow-x-hidden"
      :class="[appStore.plateform]">
      <div class="headline h-16 flex items-center text-lg">
        <slot name="headline" />
      </div>


      <div class="links overflow-x-hidden overflow-y-scroll grow">
        <NavigationDrawerLink :label="t('navigation.dashboard')"
          :to="{ name: 'Dashboard' }" @click="handleClick">
          <template #icon>
            <ChartPieIcon class="h-8 w-8 text-muted-foreground" />
          </template>
          </NavigationDrawerLink>

        <NavigationDrawerLink v-for="(center, n) in userStore.user?.centers"
          :key="center.id"
          :label="center.preferences?.label || center.title" @click="handleClick" :position="n"
          :to="{ name: 'Center', params: { centerId: center.id } }">
          <template #icon>
            <div class="h-8 w-8 flex items-center justify-center">
              <div class="w-2.5 h-2.5 rounded-full"
                :style="{ backgroundColor: getCenterColor(n + 1) }"></div>
            </div>
          </template>
        </NavigationDrawerLink>
      </div>

      <div class="my-auto overflow-x-hidden">
        <NavigationDrawerLink :label="t('navigation.profile')" @finished="handleClick"
          :to="{ name: 'Profile' }">
          <template #icon>
            <UserCircleIcon class="h-6 w-6" />
          </template>
        </NavigationDrawerLink>
      </div>
    </div>
  </Transition>
</template>
<script setup lang="ts">
import { useNavigationDrawerStore } from '../../stores/NavigationDrawerStore';
import { useUserManagerStore } from '../../stores/userManagerStore';
import { ChartPieIcon, UserCircleIcon } from '@heroicons/vue/24/outline';
import { useI18n } from 'vue-i18n';
import NavigationDrawerLink from './NavigationDrawerLink.vue';
import { useAppSettingsStore } from '../../stores/AppSettingsStore';
import { getCenterColor } from '../../utils/CenterColors';

const { t } = useI18n();
const navigationDrawerStore = useNavigationDrawerStore();

const appStore = useAppSettingsStore()
const userStore = useUserManagerStore();

const handleClick = () => {
  setTimeout(() => {
    navigationDrawerStore.close();
  }, 250);
}

</script>

<style>
.grow-right-enter-active,
.grow-right-leave-active {
  transition: max-width .25s cubic-bezier(0.86, 0, 0.07, 1);
  overflow: hidden;
}

.grow-right-enter-from,
.grow-right-leave-to {
  max-width: 0;
}

.grow-right-enter-to,
.grow-right-leave-from {
  max-width: 22.5rem;
}

</style>